export default __webpack_public_path__ + "static/media/party-popper.cfb64625.svg";